import { useState } from "react"
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom"
function Signup(props){
    const navigate = useNavigate()
    var users = props.users
    var setusers = props.setusers
    const[eusername,setEusername] = useState("")
    const[epassword,setEpassword] = useState("")
    const[eCpasswrd,setCpasswrd] = useState("")
    function handleuser(e){
        setEusername(e.target.value)
    }
    function handlepassword(e){
        setEpassword(e.target.value)
    }
    function handleConfirmpasswrd(e){
        setCpasswrd(e.target.value)
    }
    function addUser(){
       if(epassword === eCpasswrd){
        setusers([...users,{username:eusername,password:epassword}])
        navigate("/")
        
       }
       else{
        alert("Passwords do not match!")
       }
    }
    return (<div className="bg-black px-10 py-20">
        <div className="bg-white p-10 border rounded-md">
            <h1 className="text-3xl font-medium">Hey Hi 👋</h1>
            <p>You can Signup here :)</p>
            <input className="border border-black rounded-md p-1 my-2" type="text" placeholder="username" onChange={handleuser} value={eusername}/><br/>
            <input className="border border-black rounded-md p-1 my-1" type="password" placeholder="password" onChange={handlepassword} value={epassword}/><br/>
            <input className="border border-black rounded-md p-1 my-1" type="password" placeholder="confirm password" onChange={handleConfirmpasswrd} value={eCpasswrd}/><br/>
            <button className="bg-[#FCA203] px-5 py-2 my-1 border rounded-md" onClick={addUser}>SignUp</button>
            <p>Already have an account ? <Link to={"/"} className="text-blue-700 hover:underline">Login</Link></p>
        </div>
    </div>)
}
export default Signup